import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-rhode-island-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./rhode-island-state-form.component.html",
  styleUrl: "./rhode-island-state-form.component.scss",
})
export class RhodeIslandStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
